import { createStore as reduxCreateStore } from 'redux'

const reducer = (state, action) => {
  if (action.type === 'UPDATE_SEARCH_STRING') {
    return Object.assign({}, state, {
      searchString: action.searchString,
    })
  } else if (action.type === 'UPDATE_PAGES') {
    return Object.assign({}, state, {
      pages: { ...action.pages },
    })
  }
  return state
}

const initialState = { 
  searchString: '',
  pages: {}
}

const createStore = () => reduxCreateStore(reducer, initialState)

export default createStore



// WEBPACK FOOTER //
// ./src/state/store.js